import { MasonryComposableCardRenderer } from '@leagueplatform/masonry-renderers';

export const VirtualComposableCard: typeof MasonryComposableCardRenderer = (
  { css, ...rest }, // eslint-disable-line react/prop-types
) => (
  <MasonryComposableCardRenderer
    {...rest}
    css={{
      ...css,
      '& .GDS-paragraph-text > p:not(:last-child)': {
        marginBlockEnd: '$half',
      },
    }}
  />
);
